<template>
  <modal heading="Uh oh, something went wrong." :show-footer="true" @close="$emit('close')">
    <p>
      Please try reloading the page. If the issue continues to occur, please
      <a href="/page/contact-us">contact us</a> or email
      <a href="mailto:service@fitnessblender.com">service@fitnessblender.com</a>
    </p>
  </modal>
</template>

<script>
import modal from './modal.vue'
export default {
  name: 'ModalError',
  components: { modal },
  props: {},
}
</script>
